var map = {
	"./IconAI.svg": "c380",
	"./Login.svg": "98f2",
	"./LogoText.svg": "83c0",
	"./Playlists/UpcomingFeature/playlist.svg": "7b4e",
	"./access.svg": "359f",
	"./afiliateIcon.svg": "089b",
	"./analyticsEmptyState.svg": "decf",
	"./analyticsImage.svg": "250a",
	"./arrowUp.svg": "d9fc",
	"./arrow_carousel.svg": "c888",
	"./back2.svg": "e6cd",
	"./bf_panda.svg": "8be0",
	"./blueSadFeeling.svg": "2a18",
	"./boletoIcon.svg": "eb4c",
	"./brazil.svg": "5c0e",
	"./browserDRM.svg": "a3aa",
	"./bulgaria.svg": "d4c0",
	"./cc_listing.svg": "d3e0",
	"./cc_tooltip.svg": "55c6",
	"./chatIcon.svg": "72fe",
	"./chat_icon.svg": "83fb",
	"./chat_icon_gray.svg": "b314",
	"./checkbox-blank.svg": "cdd2",
	"./checkbox-filled.svg": "e050",
	"./china.svg": "a17c",
	"./circleTrainingBanner.svg": "097f",
	"./closed-captions.svg": "ecaf",
	"./credit_blue_darken_icon.svg": "0d2a",
	"./credit_blue_icon.svg": "255f",
	"./credit_buy_modal_icon.svg": "2ceb",
	"./credit_green_icon.svg": "49a2",
	"./credit_grey_icon.svg": "13c7",
	"./credit_red_danger_icon.svg": "0c5f",
	"./credit_red_icon.svg": "aeb8",
	"./credit_small_icon.svg": "2cd6",
	"./croatia.svg": "6eb1",
	"./crown.svg": "7cd5",
	"./cursor.svg": "1e92",
	"./czech-republic.svg": "2561",
	"./darkmode-video-preview-step1.svg": "82dc",
	"./darkmode-video-preview-step2.svg": "7dc5",
	"./drmLock.svg": "ee8e",
	"./drmUnlock.svg": "bea8",
	"./dub_cc.svg": "60cb",
	"./dub_listing.svg": "b91e",
	"./dubbing.svg": "d62c",
	"./ebook.svg": "417b",
	"./ebookModal.svg": "33ce",
	"./editPencil.svg": "6ed1",
	"./email-code-validation.svg": "be3d",
	"./emptyPlaylist.svg": "bad0",
	"./english.svg": "3b3b",
	"./external.svg": "ef87",
	"./finland.svg": "dd11",
	"./france.svg": "0b33",
	"./generatingAiSubtitle.svg": "4af6",
	"./germany.svg": "ba4b",
	"./greece.svg": "b6d9",
	"./headerImage.svg": "a535",
	"./hungary.svg": "ce57",
	"./icon-alert.svg": "0074",
	"./icon-video-speed.svg": "77af",
	"./icon_pix.svg": "b6d4",
	"./india.svg": "691b",
	"./indonesia.svg": "df36",
	"./italy.svg": "2299",
	"./japan.svg": "b3cd",
	"./kenya.svg": "0f7d",
	"./key.svg": "07f4",
	"./link.svg": "6bb3",
	"./link_dark.svg": "b095",
	"./listColumns.svg": "00e4",
	"./loadingAi/loadingAiStep1.svg": "42b1",
	"./loadingAi/loadingAiStep2.svg": "b0f9",
	"./loadingAi/loadingAiStep3.svg": "e0a2",
	"./loadingAi/loadingAiStep4.svg": "6d36",
	"./loadingAi/loadingAiStep5.svg": "d288",
	"./loadingAi/loadingAiStep6.svg": "4520",
	"./login-0.svg": "89f2",
	"./login-1.svg": "3f5b",
	"./login-2.svg": "87c7",
	"./login-circle.svg": "e34c",
	"./login-points.svg": "093f",
	"./loginBackground1.svg": "53a2",
	"./loginBackgroundImage1.svg": "36b7",
	"./loginImage1.svg": "f464",
	"./loginImage2.svg": "b5d4",
	"./loginImage3.svg": "a2a6",
	"./logo-panda-name.svg": "6806",
	"./logo-symbol-pandavideo.svg": "1fec",
	"./logoBlack.svg": "6a0d",
	"./logoWhite.svg": "3a24",
	"./malaysia.svg": "40f6",
	"./mastercardLogo.svg": "190a",
	"./mindMap.svg": "e27c",
	"./mindMapModal.svg": "0dda",
	"./netherlands.svg": "eebe",
	"./newFolder.svg": "27c6",
	"./nfeDisabled.svg": "dd0b",
	"./nfeEnabled.svg": "053d",
	"./noFilesImage.svg": "a6dc",
	"./norway.svg": "8e84",
	"./notifications.svg": "4170",
	"./onboardingImage1.svg": "88b4",
	"./onboardingImage2.svg": "08d1",
	"./onboardingImage3.svg": "113a",
	"./panda-assist-empty.svg": "f2fd",
	"./pandaAssistModal.svg": "0727",
	"./pandaBrandingBanner/big-play.svg": "7b17",
	"./pandaChip.svg": "4409",
	"./pandaHappy.svg": "b5a2",
	"./pandaIcons/10s-ago.svg": "a6f6",
	"./pandaIcons/10s-forward.svg": "e039",
	"./pandaIcons/ab-test.svg": "d92d",
	"./pandaIcons/add-outline.svg": "f440",
	"./pandaIcons/add.svg": "0c04",
	"./pandaIcons/additional.svg": "083a",
	"./pandaIcons/affiliates.svg": "2948",
	"./pandaIcons/ai.svg": "31cd",
	"./pandaIcons/airplay.svg": "2c00",
	"./pandaIcons/alert-outline.svg": "47de",
	"./pandaIcons/analytics.svg": "ec34",
	"./pandaIcons/back.svg": "422e",
	"./pandaIcons/brazil.svg": "46c8",
	"./pandaIcons/breadcumb.svg": "1c3c",
	"./pandaIcons/calendar.svg": "253e",
	"./pandaIcons/cc-android.svg": "8a93",
	"./pandaIcons/cc-ios.svg": "419c",
	"./pandaIcons/check-outline.svg": "8df8",
	"./pandaIcons/check-round.svg": "f4d7",
	"./pandaIcons/chev-down.svg": "df42",
	"./pandaIcons/chev-left.svg": "c9f0",
	"./pandaIcons/chev-right.svg": "cbb4",
	"./pandaIcons/chev-up.svg": "8746",
	"./pandaIcons/chromecast.svg": "6084",
	"./pandaIcons/close.svg": "8c8d",
	"./pandaIcons/code-api.svg": "849f",
	"./pandaIcons/color.svg": "56c6",
	"./pandaIcons/columns.svg": "17f7",
	"./pandaIcons/config.svg": "2672",
	"./pandaIcons/copy.svg": "9e3a",
	"./pandaIcons/credit-card.svg": "b8a9",
	"./pandaIcons/customPixel.svg": "a5a0",
	"./pandaIcons/dislike.svg": "fabf",
	"./pandaIcons/doc.svg": "f3f4",
	"./pandaIcons/download.svg": "6493",
	"./pandaIcons/draft.svg": "c873",
	"./pandaIcons/drm-off.svg": "8a21",
	"./pandaIcons/drm-on.svg": "8ac9",
	"./pandaIcons/edit.svg": "a2f2",
	"./pandaIcons/error-outline.svg": "56c5",
	"./pandaIcons/error-solid.svg": "9a4a",
	"./pandaIcons/extra-content.svg": "d8ce",
	"./pandaIcons/eye-appearing.svg": "a095",
	"./pandaIcons/eye-hidden.svg": "9ba7",
	"./pandaIcons/facebook.svg": "85a8",
	"./pandaIcons/filter.svg": "7089",
	"./pandaIcons/finance.svg": "bf13",
	"./pandaIcons/folder.svg": "ce5f",
	"./pandaIcons/fonts/panda.svg": "4eb4",
	"./pandaIcons/fullscreen.svg": "5417",
	"./pandaIcons/gigabites.svg": "43f8",
	"./pandaIcons/globe-darkmode.svg": "f057",
	"./pandaIcons/globe.svg": "0474",
	"./pandaIcons/go.svg": "d456",
	"./pandaIcons/google.svg": "9bcd",
	"./pandaIcons/googleAdsLogo.svg": "6df1",
	"./pandaIcons/help-outline.svg": "7d0a",
	"./pandaIcons/help-solid.svg": "5c38",
	"./pandaIcons/history.svg": "76cd",
	"./pandaIcons/hour.svg": "44d1",
	"./pandaIcons/ia-credits.svg": "1c1b",
	"./pandaIcons/indent.svg": "8e27",
	"./pandaIcons/info-outline.svg": "3337",
	"./pandaIcons/info-solid.svg": "afb9",
	"./pandaIcons/key.svg": "d4aa",
	"./pandaIcons/language.svg": "9cb2",
	"./pandaIcons/like.svg": "121c",
	"./pandaIcons/likeplus.svg": "2c70",
	"./pandaIcons/link.svg": "4016",
	"./pandaIcons/live.svg": "2792",
	"./pandaIcons/loading-25.svg": "4301",
	"./pandaIcons/logout.svg": "923b",
	"./pandaIcons/manage.svg": "bb55",
	"./pandaIcons/menu-action.svg": "28d8",
	"./pandaIcons/menu.svg": "20f8",
	"./pandaIcons/metaLogo.svg": "596d",
	"./pandaIcons/mini-player.svg": "9298",
	"./pandaIcons/minimize.svg": "cac6",
	"./pandaIcons/minus-outline.svg": "ce49",
	"./pandaIcons/minus.svg": "2684",
	"./pandaIcons/news.svg": "36ed",
	"./pandaIcons/notification.svg": "1c51",
	"./pandaIcons/pause.svg": "14dc",
	"./pandaIcons/pip.svg": "92ad",
	"./pandaIcons/placeholder-ic.svg": "f1cf",
	"./pandaIcons/plataformas-cademi.svg": "3e14",
	"./pandaIcons/plataformas-eduzz.svg": "083f",
	"./pandaIcons/plataformas-hotmart.svg": "cda5",
	"./pandaIcons/plataformas-memberkit.svg": "4cb3",
	"./pandaIcons/plataformas-the-members.svg": "9447",
	"./pandaIcons/plataformas-ticto.svg": "0315",
	"./pandaIcons/plataformas-xgrow.svg": "7bd4",
	"./pandaIcons/play.svg": "e66b",
	"./pandaIcons/player-search.svg": "3063",
	"./pandaIcons/player-settings.svg": "975d",
	"./pandaIcons/player.svg": "65b0",
	"./pandaIcons/playlist.svg": "368f",
	"./pandaIcons/promo-tag.svg": "f4ba",
	"./pandaIcons/reais.svg": "183e",
	"./pandaIcons/record.svg": "7c03",
	"./pandaIcons/redo.svg": "7959",
	"./pandaIcons/remove.svg": "983a",
	"./pandaIcons/search.svg": "67a7",
	"./pandaIcons/security-on.svg": "968b",
	"./pandaIcons/security.svg": "598e",
	"./pandaIcons/send.svg": "8360",
	"./pandaIcons/sort-down.svg": "df2c",
	"./pandaIcons/sort-up.svg": "4fd4",
	"./pandaIcons/status-system.svg": "77ff",
	"./pandaIcons/terabites.svg": "aa55",
	"./pandaIcons/theme-day.svg": "5284",
	"./pandaIcons/theme-night.svg": "d52c",
	"./pandaIcons/undo.svg": "d692",
	"./pandaIcons/upload.svg": "a237",
	"./pandaIcons/video.svg": "578f",
	"./pandaIcons/videos.svg": "0acc",
	"./pandaIcons/voice.svg": "f00c",
	"./pandaIcons/volume-max.svg": "c47a",
	"./pandaIcons/volume-min.svg": "9c85",
	"./pandaIcons/volume-mute.svg": "199a",
	"./pandaLogo.svg": "523f",
	"./pandaLogoDarkTheme.svg": "e548",
	"./pandaMainLogo.svg": "9cd2",
	"./pandaMark.svg": "3eac",
	"./pandaSad.svg": "35f7",
	"./pandaStroke.svg": "9e61",
	"./pandaToolbarDark.svg": "de0a",
	"./panda_abtest_icon.svg": "d182",
	"./panda_add_video.svg": "d4ed",
	"./panda_afilliate_icon.svg": "645f",
	"./panda_analytics_icon.svg": "5a0b",
	"./panda_assistAi_icon.svg": "c05e",
	"./panda_chat_icon.svg": "f292",
	"./panda_config_icon.svg": "a5d3",
	"./panda_finance_icon.svg": "ade7",
	"./panda_help_icon.svg": "3d09",
	"./panda_live_icon.svg": "afaf",
	"./panda_news_icon.svg": "e71f",
	"./panda_octainfo_icon.svg": "fe61",
	"./panda_org_icon.svg": "67f9",
	"./panda_player_icon.svg": "6287",
	"./panda_playlist_icon.svg": "9c88",
	"./panda_safety_icon.svg": "d2d1",
	"./panda_status_icon.svg": "073d",
	"./panda_theme_icon.svg": "c1f7",
	"./panda_videos_icon.svg": "e3ad",
	"./password-create.svg": "125f",
	"./playBoxOutline.svg": "fc72",
	"./playerTabs/controls/icons/airplay.svg": "a2f5",
	"./playerTabs/controls/icons/captions.svg": "3a84",
	"./playerTabs/controls/icons/cast.svg": "b814",
	"./playerTabs/controls/icons/fast-forward.svg": "9da8",
	"./playerTabs/controls/icons/fullscreen.svg": "6fad",
	"./playerTabs/controls/icons/pip.svg": "5818",
	"./playerTabs/controls/icons/play-large.svg": "c3f2",
	"./playerTabs/controls/icons/play.svg": "7178",
	"./playerTabs/controls/icons/rewind.svg": "9042",
	"./playerTabs/controls/icons/settings.svg": "5ec6",
	"./playerTabs/controls/icons/smart-search.svg": "8fb8",
	"./playerTabs/controls/icons/volume.svg": "d401",
	"./playlist-placeholder.svg": "aa65",
	"./playlist.svg": "9fd3",
	"./playlistEmptyState.svg": "29b0",
	"./playlistPage/loading-thumb-video-play.svg": "4b88",
	"./playlistPage/placeholder-pandaplaylist.svg": "1610",
	"./playlist_key.svg": "d099",
	"./playlist_link.svg": "bc4f",
	"./poland.svg": "fb65",
	"./preload-en.svg": "c7f4",
	"./preload-pt.svg": "bbf1",
	"./preparingAccount.svg": "0e35",
	"./progressIcon.svg": "42fe",
	"./purchaseFailed.svg": "bb33",
	"./purchaseSuccess.svg": "5afa",
	"./recap/mainPageRecapBanner/recapBanner-part1.svg": "c6cd4",
	"./recap/mainPageRecapBanner/recapBanner-part2.svg": "2fde",
	"./recap/mainPageRecapBanner/recapBanner-part3.svg": "9ccb",
	"./recap/mainPageRecapBanner/recapBanner-part4.svg": "8d56",
	"./recap/mainPageRecapBanner/recapBanner-part5.svg": "d295",
	"./recap/navDrawerRecapBanner/navRecapBanner2024-en.svg": "b1bf",
	"./recap/navDrawerRecapBanner/navRecapBanner2024-es.svg": "bf79",
	"./recap/navDrawerRecapBanner/navRecapBanner2024-pt.svg": "1a44",
	"./recap/recapModal/modalRecapSvg.svg": "a1ce",
	"./recap/recapModal/modalRecapSvg2024-en.svg": "0724",
	"./recap/recapModal/modalRecapSvg2024-es.svg": "f4c0",
	"./recap/recapModal/modalRecapSvg2024-pt.svg": "e051",
	"./robot.svg": "2b1c",
	"./romania.svg": "6ac6",
	"./russia.svg": "266f",
	"./s3.svg": "d802",
	"./saudi-arabia.svg": "23da",
	"./sendButton-disabled.svg": "b0481",
	"./sendButton.svg": "c382",
	"./serbia.svg": "ac20",
	"./shortly-panda-assist-ai.svg": "7932",
	"./slovakia.svg": "3da7",
	"./snackbar/icons/alert-solid.svg": "f99b",
	"./snackbar/icons/check-round.svg": "163c",
	"./snackbar/icons/error-solid.svg": "85de",
	"./snackbar/icons/info-solid.svg": "e8fb",
	"./south-korea.svg": "14c8",
	"./spanish.svg": "1be0",
	"./summary.svg": "d927",
	"./sweden.svg": "772b",
	"./techLines.svg": "2a31",
	"./thailand.svg": "65e7",
	"./thumbUploadIcon.svg": "9115",
	"./turkey.svg": "b45f",
	"./ukraine.svg": "b529",
	"./undraw_live.svg": "37e6",
	"./undraw_partying.svg": "ea1e",
	"./undraw_real_time_analytics.svg": "158c",
	"./upload.svg": "c118",
	"./uploadIcon.svg": "0752",
	"./verticalDots.svg": "35e6",
	"./video-download-offline.svg": "ec97",
	"./video-preview-step1.svg": "f2a2",
	"./video-preview-step2.svg": "c8ad",
	"./video-preview.svg": "b430",
	"./video_file.svg": "6dff",
	"./videosEmptyState.svg": "657d",
	"./videosIcon.svg": "3976",
	"./vietnam.svg": "5b81",
	"./vimeoicon.svg": "e988",
	"./visaCard.svg": "d46f",
	"./waitingLive.svg": "8f87",
	"./warningIcon.svg": "4772",
	"./watchLive.svg": "73a9",
	"./ytb.svg": "945f",
	"./zoomInIcon.svg": "8b4c",
	"./zoomOutIcon.svg": "bf66",
	"./zoomToFitIcon.svg": "a5b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";